import { useEffect, useState } from 'react';

export type Theme = 'light' | 'dark';
const KEY = 'theme';

// Dark is the default; only an explicit stored "light" opts out.
export const getStoredTheme = (): Theme => {
  try {
    return localStorage.getItem(KEY) === 'light' ? 'light' : 'dark';
  } catch {
    return 'dark';
  }
};

export const applyTheme = (t: Theme) => {
  document.documentElement.classList.toggle('dark', t === 'dark');
  try {
    localStorage.setItem(KEY, t);
  } catch {
    /* ignore storage errors (private mode) */
  }
};

/** Theme state hook: returns the current theme and a toggle. */
export const useTheme = (): [Theme, () => void] => {
  const [theme, setTheme] = useState<Theme>(getStoredTheme);
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);
  // Derive the next theme from the actual DOM state so multiple toggle instances
  // (desktop + mobile header) never disagree.
  const toggle = () =>
    setTheme(document.documentElement.classList.contains('dark') ? 'light' : 'dark');
  return [theme, toggle];
};
